import React from 'react';
import { Link } from 'react-router-dom';
import { stores } from '../data/mockData';
import { ArrowRight, Star, Bed } from 'lucide-react';

const StoreLogos = () => {
  const storeLogos = {
    casper: { text: 'casper', color: '#00008B', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    purple: { text: 'purple', color: '#4C1D95', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    'tempur-pedic': { text: 'TEMPUR-PEDIC', color: '#1E3A5F', bg: '#fff', font: 'font-bold text-sm md:text-base tracking-wide' },
    'sleep-number': { text: 'Sleep Number', color: '#004B87', bg: '#fff', font: 'font-bold text-lg md:text-xl' },
    nectar: { text: 'NECTAR', color: '#F59E0B', bg: '#fff', font: 'font-extrabold text-xl md:text-2xl tracking-wide' },
    saatva: { text: 'SAATVA', color: '#1a472a', bg: '#fff', font: 'font-semibold text-xl md:text-2xl tracking-[0.15em]' },
    helix: { text: 'helix', color: '#1E40AF', bg: '#fff', font: 'font-bold text-xl md:text-2xl italic' },
    'brooklyn-bedding': { text: 'BROOKLYN BEDDING', color: '#374151', bg: '#fff', font: 'font-bold text-xs md:text-sm tracking-wide' },
    leesa: { text: 'leesa', color: '#374151', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    beautyrest: { text: 'BEAUTYREST', color: '#1E293B', bg: '#fff', font: 'font-medium text-lg md:text-xl tracking-wider' },
    'mattress-firm': { text: 'MATTRESS FIRM', color: '#DC2626', bg: '#fff', font: 'font-extrabold text-sm md:text-base tracking-wide' },
    amerisleep: { text: 'amerisleep', color: '#059669', bg: '#fff', font: 'font-bold text-lg md:text-xl' },
    'tuft-needle': { text: 'tuft & needle', color: '#1E40AF', bg: '#fff', font: 'font-semibold text-lg md:text-xl' },
    'bear-mattress': { text: 'BEAR', color: '#374151', bg: '#fff', font: 'font-black text-xl md:text-2xl' },
    avocado: { text: 'AVOCADO', color: '#166534', bg: '#fff', font: 'font-bold text-lg md:text-xl tracking-wide' },
    ghostbed: { text: 'GhostBed', color: '#6B21A8', bg: '#fff', font: 'font-bold text-lg md:text-xl' },
    dreamcloud: { text: 'DREAMCLOUD', color: '#1E3A5F', bg: '#fff', font: 'font-semibold text-base md:text-lg tracking-wider' },
    'boll-branch': { text: 'Boll & Branch', color: '#1E293B', bg: '#fff', font: 'font-medium text-lg md:text-xl' },
    brooklinen: { text: 'BROOKLINEN', color: '#1E293B', bg: '#fff', font: 'font-bold text-base md:text-lg tracking-wider' },
    parachute: { text: 'PARACHUTE', color: '#374151', bg: '#fff', font: 'font-medium text-lg md:text-xl tracking-[0.1em]' },
    coyuchi: { text: 'coyuchi', color: '#92400E', bg: '#fff', font: 'font-medium text-xl md:text-2xl lowercase' },
    'layla-sleep': { text: 'Layla', color: '#7C3AED', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    sealy: { text: 'SEALY', color: '#1E40AF', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    serta: { text: 'SERTA', color: '#1E3A5F', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-wide' },
  };

  const renderStoreLogo = (store) => {
    const logoInfo = storeLogos[store.slug];
    if (!logoInfo) {
      return <span className="text-lg font-bold text-slate-700">{store.name}</span>;
    }

    return (
      <span
        className={`${logoInfo.font || 'text-xl md:text-2xl font-bold'}`}
        style={{ color: logoInfo.color }}
      >
        {logoInfo.text}
      </span>
    );
  };

  const displayStores = [
    ...stores.filter(s => ['casper', 'purple', 'tempur-pedic', 'sleep-number', 'nectar'].includes(s.slug)),
    ...stores.filter(s => ['saatva', 'helix', 'brooklyn-bedding', 'brooklinen', 'parachute'].includes(s.slug)),
  ].slice(0, 10);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
              <span className="text-sm font-semibold text-amber-600 uppercase tracking-wider">Featured</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">Top Sleep Brands</h2>
          </div>
          <Link 
            to="/stores" 
            className="flex items-center gap-2 text-red-600 font-semibold hover:text-red-700 transition-colors group"
          >
            View all stores
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Store Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {displayStores.map((store, index) => (
            <Link
              key={store.id}
              to={`/store/${store.slug}`}
              className="group bg-white border-2 border-slate-100 rounded-2xl p-6 flex items-center justify-center min-h-[100px] md:min-h-[120px] hover:border-red-200 hover:shadow-xl hover:shadow-red-100/50 transition-all duration-300 animate-fadeInUp opacity-0"
              style={{ animationDelay: `${index * 0.05}s`, animationFillMode: 'forwards' }}
            >
              <div className="transform group-hover:scale-110 transition-transform duration-300">
                {renderStoreLogo(store)}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoreLogos;
